/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */
'use strict';

var useRelayEnvironment = require('./useRelayEnvironment');

var _require = require('react'),
    useEffect = _require.useEffect;

var _require2 = require('relay-runtime'),
    requestSubscription = _require2.requestSubscription;

function useSubscription(config, requestSubscriptionFn) {
  // N.B. this will re-subscribe every render if config or requestSubscriptionFn
  // are not memoized.
  // Please do not pass an object defined in-line.
  var actualRequestSubscription = requestSubscriptionFn !== null && requestSubscriptionFn !== void 0 ? requestSubscriptionFn : requestSubscription;
  var environment = useRelayEnvironment();
  useEffect(function () {
    // $FlowFixMe[method-unbinding] added when improving typing for this parameters
    var _actualRequestSubscri = actualRequestSubscription(environment, config),
        dispose = _actualRequestSubscri.dispose; // $FlowFixMe[incompatible-call]


    return dispose;
  }, [environment, config, actualRequestSubscription]);
}

module.exports = useSubscription;